import React from 'react';
import { Hero } from '../components/sections/Hero';
import { UrgentJobBanner } from '../components/sections/UrgentJobBanner';
import { ShirtPromoBadge } from '../components/sections/ShirtPromoBadge';
import { TiePromoBadge } from '../components/sections/TiePromoBadge';
import { CarpetPromoBadge } from '../components/sections/CarpetPromoBadge';
import { HomeSeoStrip } from '../components/sections/HomeSeoStrip';

const Home = () => {
  return (
    <div data-testid="home-page">
      <div className="pt-32 sm:pt-48 space-y-3">
        <CarpetPromoBadge />
        <ShirtPromoBadge />
        <TiePromoBadge />
        <UrgentJobBanner />
      </div>
      <Hero />
      <HomeSeoStrip />
    </div>
  );
};

export default Home;
